(() => {
	let survey = document.querySelector('[data-survey]');
	if (!survey) {
		return;
	}

    if (location.hash === '#survey') {
        window.localStorage.surveyDismissed = false;
    }

    if (!window.localStorage.surveyDismissed || window.localStorage.surveyDismissed === 'false') {
        setTimeout(() => {
            survey.classList.add('survey--unhide');
            setTimeout(() => {
                survey.classList.add('survey--show');
            }, 10);
        }, 1400);
    }

    document.querySelector('[data-survey-dismiss]').addEventListener('click', () => {
        window.localStorage.surveyDismissed = 'true';
        survey.classList.remove('survey--unhide');
    });

    document.querySelector('[data-survey-enter]').addEventListener('click', () => {
        window.localStorage.surveyDismissed = 'true';
    });

})();